import { runIf } from './function-utils';
import { SITE_DOMAINS, SITE_NAMES } from './constants';

export const AUTHOR_CLASS_NAME = 'author';
export const PUBLISH_CLASS_NAME = 'publish';
export const HOME_PAGE_CLASS_NAME = 'home-page';
export const SECTION_HOME_PAGE_CLASS_NAME = 'section-hp';
export const SUB_SECTION_HOME_PAGE_CLASS_NAME = 'subsection-hp';
export const SPECIAL_PAGE_CLASS_NAME = 'speciali-page';
export const ARTICLE_PAGE_CLASS_NAME = 'article-page';
export const NEWS_U_CAN_USE_PAGE_CLASS_NAME = 'tabs-page';
export const LIVE_BLOG_PAGE_CLASS_NAME = 'liveblog-page';
export const LIVE_BLOG_SCRIBBLE_CLASS_NAME = 's-liveblog';
export const LIVE_BLOG_MANAGER_CLASS_NAME = 'lvbg-liveblog';
export const GALLERY_PAGE_CLASS_NAME = 'gallery-page';
export const PREFERENCES_PAGE_CLASS_NAME = 'preferences-page';
export const FREE_HTML_PAGE = 'free-html-page';
export const HIGHLIGHTS_PAGE = 'highlights';
export const SQUAD_PAGE = 'squadra';
export const SQUAD_PAGE_NEWS = 'news-squadra';
export const SPORT_DATA_PAGES = [
  'calendar-page',
  'results-page',
  'player-page',
  'calciomercato-tabellone-page',
  'calciomercato-squadra-page',
  'calendario-gare-page',
  'competition-calendar-results',
  'competition-calendar',
  'competition-ranking',
  'competition-results',
  'competition-scores',
  'dettaglio-gare-page',
  'dettaglio-pilota-page',
  'dettaglio-team-page',
  'gp-detail-page',
  'last-gp-results-page',
  'lineups-page',
  'live-page',
  'municipalities',
  'municipality-details',
  'pagelle',
  'probabili-formazioni-page',
  'ranking-page',
  'region-details',
  'single-gp-results-page',
  'team-calendar-results',
  'team-calendar',
  'team-driver-list-page',
  'team-driver-single-page',
  'team-piloti-list-page',
  'team-ranking',
  'team-results',
  'programmazione-page',
];
export const ELECTION_PAGES = [
  'elections-archive-page',
  'municipality-details',
  'municipalities',
  'regional',
  'regional-details',
];
export const SPORTS_DATA_LIVE_MATCH_PAGES = 'base-tab-page';
export const SPORTS_DATA_LIVE_GP_PAGES = 'live-gp-detail-page';
export const HOROSCOPES_PAGES = [
  'oroscopo-home-page',
  'oroscopo-index-page',
  'oroscopo-dettaglio-segno-page',
  'oroscopo-affinita-homepage',
  'significato-nome-page',
];
export const HP_ENTERTAINMENT = 'isEntertainment';
export const HOROSCOPE_COOKIE_NAME = 'oroscopo';
const WRAPPER_PAGE_CLASS = 'l-wrapper';
const MEANING_NAME = 'significato-nome-page';
const HOROSCOPE_HP = 'oroscopo-home-page';
const AFFINITY_HP = 'oroscopo-affinita-homepage';
const HOROSCOPE_DETAIL_SIGN_PAGE = 'oroscopo-dettaglio-segno-page';
const LMP_TAB_SELECTOR = '.ftbl__tab-item';
const LMP_MENU_ITEM_CLICKED_EVENT = 'lmp_menu_item_clicked';
const LMP_TABS_MENU_SELECTOR = '.j-tabs-menu';
const LATEST_NEWS_PAGE_CLASS_NAME = 'latest-news-page';
const WEBVIEW_CLASS_NAME = 'webview';
const VIDEO_ARTICLE = 'video-article-page';
const PREMIUM_ARTICLE_PAGE = 'premium-page';
const PREMIUM_ARTICLE_PAGE_V2 = 'insider-article-page';

export const isParselyRecommendationEnabled = (parselyTopNewsId) =>
  document.querySelector(`#${parselyTopNewsId}`)
    ? document.querySelector(`#${parselyTopNewsId}`).getAttribute('data-isParselyRecommendationEnabled')
    : undefined;

export const isEntertainmentDomain = () =>
  document.querySelector(`.${WRAPPER_PAGE_CLASS}`)?.classList.contains(HP_ENTERTAINMENT);

export const isSportDomain = () => Boolean(window.location.origin.match(/sport.sky.it/g));

export const isTg24Domain = () => Boolean(window.location.origin.match(/tg24.sky.it/g));

export const getDomainName = () => {
  if (isEntertainmentDomain()) {
    return SITE_DOMAINS.ENTERTAINMENT;
  }
  if (isTg24Domain()) {
    return SITE_DOMAINS.NEWS;
  }
  if (isSportDomain()) {
    return SITE_DOMAINS.SPORT;
  }
};

export const getSiteName = () => {
  if (isLocalDomain()) {
    return SITE_NAMES.NEWS; // Just as a local test we put "tg24"
  }

  if (isEntertainmentDomain()) {
    return SITE_NAMES.ENTERTAINMENT;
  }
  if (isTg24Domain()) {
    return SITE_NAMES.NEWS;
  }
  if (isSportDomain()) {
    return SITE_NAMES.SPORT;
  }
};

export const isDevDomain = () =>
  Boolean(window.location.origin.match(/dev.tg24.sky.it/g) || window.location.origin.match(/dev.sport.sky.it/g));

export const isTestDomain = () =>
  Boolean(window.location.origin.match(/test.tg24.sky.it/g) || window.location.origin.match(/test.sport.sky.it/g));

export const isStageDomain = () =>
  Boolean(window.location.origin.match(/stage.tg24.sky.it/g) || window.location.origin.match(/stage.sport.sky.it/g));

export const isLocalDomain = () => Boolean(window.location.origin.match(/localhost/g));

export const isNoProdDomain = () => isLocalDomain() || isDevDomain() || isTestDomain() || isStageDomain();

export const isProdDomain = () => !isNoProdDomain();

/**
 * Get the HP url for the current site
 * @returns {String} home page url
 */
export const getHomePageUrl = () => {
  if (isLocalDomain()) {
    return 'https://localhost.sky.it:4200/';
  }
  if (isEntertainmentDomain()) {
    return `${window.location.origin}/${SITE_DOMAINS.ENTERTAINMENT}`;
  }
  return window.location.origin;
};

/**
 * Land on a new url
 * @param {String} url to land on
 */
export const goToUrl = (url) => {
  window.location.href = url;
};

/**
 * Utility function for Sport PARSELY apikey control
 */
export const isSportParselyApikey = () => Boolean(window.PARSELY?.config?.apikey?.match(/skysport.it/g));

/**
 * Utility function for Tg24 PARSELY apikey control
 */
export const isTg24ParselyApikey = () => Boolean(window.PARSELY?.config?.apikey?.match(/skytg24.it/g));

/**
 * Utility function for AuthorMode -- (Preview mode only not editor)
 */
export const isAuthorMode = () => document.documentElement.classList.contains(AUTHOR_CLASS_NAME);

/**
 * Utility function for PublishMode
 */
export const isPublishMode = () => document.documentElement.classList.contains(PUBLISH_CLASS_NAME);

/**
 * Function for checking page
 *  @param {string} classControl - the string of the class selected
 *  @param {object} bodyObj - the object body for check class
 */
export const checkPage = (classControl, bodyObj) => bodyObj.classList.contains(classControl);

export const isHomePage = () => document.body.classList.contains(HOME_PAGE_CLASS_NAME);

export const isSectionHome = () => document.body.classList.contains(SECTION_HOME_PAGE_CLASS_NAME);

export const isSubSectionHome = () => document.body.classList.contains(SUB_SECTION_HOME_PAGE_CLASS_NAME);

export const isWebView = () => document.body.classList.contains(WEBVIEW_CLASS_NAME);

export const isSpecialPage = () => document.body.classList.contains(SPECIAL_PAGE_CLASS_NAME);

export const isArticlePage = () => document.body.classList.contains(ARTICLE_PAGE_CLASS_NAME);

export const isNewsYouCanUsePage = () => document.body.classList.contains(NEWS_U_CAN_USE_PAGE_CLASS_NAME);

export const isGalleryPage = () => document.body.classList.contains(GALLERY_PAGE_CLASS_NAME);

export const isLiveBlogPage = () => document.body.classList.contains(LIVE_BLOG_PAGE_CLASS_NAME);
export const isLiveBlogManager = () =>
  isLiveBlogPage() && document.body.classList.contains(LIVE_BLOG_MANAGER_CLASS_NAME);
export const isLiveBlogScribble = () =>
  isLiveBlogPage() && document.body.classList.contains(LIVE_BLOG_SCRIBBLE_CLASS_NAME);

export const isHighlightsPage = () => document.body.classList.contains(HIGHLIGHTS_PAGE);

export const isSquadPage = () => document.body.classList.contains(SQUAD_PAGE);

export const isSquadPageNews = () => document.body.classList.contains(SQUAD_PAGE_NEWS);

export const isSportDataPage = () => SPORT_DATA_PAGES.some((element) => document.body.classList.contains(element));

export const isSportsDataLiveMatchPage = () => document.body.classList.contains(SPORTS_DATA_LIVE_MATCH_PAGES);

export const isSportsDataLiveGpPage = () => document.body.classList.contains(SPORTS_DATA_LIVE_GP_PAGES);

export const isLatestNewsPage = () => document.body.classList.contains(LATEST_NEWS_PAGE_CLASS_NAME);

export const isElectionsPage = () => ELECTION_PAGES.some((element) => document.body.classList.contains(element));

export const isUserPreferencesPage = () => document.body.classList.contains(PREFERENCES_PAGE_CLASS_NAME);

export const isPremiumPage = () => document.body.classList.contains(PREMIUM_ARTICLE_PAGE);

export const isPremiumPageV2 = () => document.body.classList.contains(PREMIUM_ARTICLE_PAGE_V2);

export const isVideoArticlePage = () => document.body.classList.contains(VIDEO_ARTICLE);

/**
 * Check if is in a Horoscope page and is the homepage
 */
export const isHoroscopeHomepage = () => document.body.classList.contains(HOROSCOPE_HP);

/**
 * Check if is in a Horoscope page and is in Affinità di Coppia
 */
export const isHoroscopeAffinity = () => document.body.classList.contains(AFFINITY_HP);

/**
 * Check if is in a Horoscope page and is in Dettaglio Segno
 */
export const isHoroscopeDetailSignPage = () => document.body.classList.contains(HOROSCOPE_DETAIL_SIGN_PAGE);

/**
 * Check if is in Significato Nome page
 */
export const isMeaningNamePage = () => checkPage(MEANING_NAME, document.body);
// export const isMeaningNamePage = checkPage(MEANING_NAME, document.body);

export const isHoroscopePages = () => HOROSCOPES_PAGES.some((element) => document.body.classList.contains(element));

export const isFreeHtmlPage = () => document.body.classList.contains(FREE_HTML_PAGE);

/**
 * Check if is a template for sticky carousel
 */
const stickyCarouselTemplates = [
  isElectionsPage,
  isHomePage,
  isSectionHome,
  isSubSectionHome,
  isSpecialPage,
  isSquadPage,
  isGalleryPage,
  isSquadPageNews,
  isSportDataPage,
  isHoroscopePages,
  isFreeHtmlPage,
  isLatestNewsPage,
];
export const isStickyCarouselTemplateEnable = () =>
  stickyCarouselTemplates.map((stickyCarouselTemplate) => stickyCarouselTemplate()).some(Boolean);

/**
 * Run an array of functions on ALL domains
 * @returns {function}
 */
export const runOnAllDomains = runIf(true);

/**
 * Run an array of functions on DEV, TEST, STAGE & PROD domains
 * @returns {function}
 */
export const runOnDevTestStageProdDomains = runIf(!isLocalDomain());
/**
 * Run an array of functions on DEV, TEST & STAGE domains
 * @returns {function}
 */
export const runOnAllButProd = runIf(isNoProdDomain());

/**
 * Run an array of functions on TEST, STAGE & PROD domains
 * @returns {function}
 */
export const runOnTestStageProdDomains = runIf(!isLocalDomain() && !isDevDomain());

/**
 * Run an array of functions just on STAGE & PROD domains
 * @returns {function}
 */
export const runOnStageProdDomain = runIf(!isLocalDomain() && !isDevDomain() && !isTestDomain());

export const hasLmpTab = () => Boolean(document.querySelector(LMP_TAB_SELECTOR));

export const onLmpTabChange = (callback) => {
  const $tabsMenu = document.querySelector(LMP_TABS_MENU_SELECTOR);
  if ($tabsMenu) {
    $tabsMenu.addEventListener(LMP_MENU_ITEM_CLICKED_EVENT, callback);
  }
};

/**
 * Get the appropriate static domain based on environment
 * @returns {string} The static domain URL
 */
export const getStaticDomain = () => {
  if (isLocalDomain()) {
    return 'https://dev.static.sky.it';
  } else if (isDevDomain()) {
    return 'https://dev.static.sky.it';
  } else if (isTestDomain()) {
    return 'https://test.static.sky.it';
  } else if (isStageDomain()) {
    return 'https://stage.static.sky.it';
  }
  return 'https://static.sky.it';
};
